import React, {useEffect, useState} from 'react';
import axios from "axios";
import parseValues from "../utils/parseValues";
import HEADERS from "../components/CSVHeaders";

const UseFetch = (APIUrl) => {
    const [data, setData] = useState([]);
    const [isFetching, setIsFetching] = useState(true);

    useEffect(() => {
        axios.get(APIUrl).then(({data}) => {
            const rows = data.split(/\r?\n/);
            const values = parseValues(rows.slice(1), HEADERS);
            setData(values);
            setIsFetching(false);
        })
    }, [])
    return [data, isFetching];
};

export default UseFetch;